export enum OBSERVATIONS_FILTERS {
  ASSET_ID = "filter[asset_id]",
  CATEGORY = "filter[category]",
  SOURCE_INTERVENTION = "filter[source_intervention]",
}
